export function formatOutsideLink(link) {
  return /^https?:\/\//.test(link) ? link : `https://${link}`;
}
